var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreative(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8L24 12M8 28L28 8L24 4L4 24L8 28ZM12 4C12 4.70724 12.281 5.38552 12.781 5.88562C13.2811 6.38572 13.9594 6.66667 14.6667 6.66667C13.9594 6.66667 13.2811 6.94762 12.781 7.44772C12.281 7.94781 12 8.62609 12 9.33333C12 8.62609 11.719 7.94781 11.219 7.44772C10.7189 6.94762 10.0406 6.66667 9.33333 6.66667C10.0406 6.66667 10.7189 6.38572 11.219 5.88562C11.719 5.38552 12 4.70724 12 4ZM25.3333 17.3333C25.3333 18.0406 25.6143 18.7189 26.1144 19.219C26.6145 19.719 27.2928 20 28 20C27.2928 20 26.6145 20.281 26.1144 20.781C25.6143 21.2811 25.3333 21.9594 25.3333 22.6667C25.3333 21.9594 25.0524 21.2811 24.5523 20.781C24.0522 20.281 23.3739 20 22.6667 20C23.3739 20 24.0522 19.719 24.5523 19.219C25.0524 18.7189 25.3333 18.0406 25.3333 17.3333Z",
    stroke: "#F16434",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreative);
export default __webpack_public_path__ + "static/media/creative.3b5c5ebce10e45197ad389f10e62bc36.svg";
export { ForwardRef as ReactComponent };